module.exports = __webpack_public_path__ + "img/btcnomessage.4f2f8aa6.png";